import {doAjax} from 'surveylabJsAssets/common/_ajax';
import {Modal} from "bootstrap";

export default function () {
    $(function () {
        const $helpBtn = $('.help-button');
        const $modal = $('#help-modal');
        const modal = new Modal(document.getElementById('help-modal'));

        $helpBtn.on('click', function () {
            modal.show();
        });

        $modal.on('shown.bs.modal', function () {
            let counter = {
                'pageID': $("input[name='hidden-page-id']").val(),
                'userSurveyID': $("input[name='hidden-user-survey-id']").val()
            };
            let countHelpUrl = $('#count-help-url').val();
            doAjax({url: countHelpUrl, data: counter});
        });
    });
}